import SearchRoadRoutingRequest from "../../../utils/search-road-route/search-road-routing.request";
import SearchRoadRoutingResponse from "../../../utils/search-road-route/search-road-routing.response";
import searchRoadRoutingService from "../../../utils/search-road-route/search-road-routing.service";
import railyApiService from "../raily-api.service";
import orderOptimizerListRequestFactory from "./list/order-optimizer-list-request.factory";
import OrderOptimizerListRequest, {
  OrderOptimizerListRequestQueryParams,
} from "./list/order-optimizer-list.request";
import OrderOptimizerListResponse from "./list/order-optimizer-list.response";
import OrderOptimizerOptimizationStatusRequest from "./optimization-status/order-optimizer-optimization-status.request";
import OrderOptimizerOptimizationStatusResponse from "./optimization-status/order-optimizer-optimization-status.response";
import OrderOptimizerPotentialDriversListRequest, {
  OrderOptimizerPotentialDriversListQueryParams,
} from "./potential-drivers-list/order-optimizer-potential-drivers-list.request";
import OrderOptimizerPotentialDriversListResponse from "./potential-drivers-list/order-optimizer-potential-drivers-list.response";
import orderOptimizerPotentialDriversListRequestFactory from "./potential-drivers-list/order-optimizer-potential-drivers-list-request.factory";
import OrderOptimizerDetailsOtherRequest from "./details/other/order-optimizer-details-other.request";
import OrderOptimizerDetailsOtherResponse from "./details/other/order-optimizer-details-other.response";
import orderOptimizerDetailsOtherRequestFactory from "./details/other/order-optimizer-details-other-request.factory";
import orderOptimizerDetailsCargoRequestFactory from "./details/cargo/order-optimizer-details-cargo-request.factory";
import OrderOptimizerDetailsCargoRequest from "./details/cargo/order-optimizer-details-cargo.request";
import OrderOptimizerDetailsCargoResponse from "./details/cargo/order-optimizer-details-cargo.response";
import OrderOptimizerDetailsUpdateRequest from "./details/update/order-optimizer-details-update.request";
import orderOptimizerDetailsUpdateRequestFactory from "./details/update/order-optimizer-details-update-request.factory";
import OrderOptimizerDetailsUpdateResponse from "./details/update/order-optimizer-details-update.response";

const orderOptimizerApiService = () => {
  const optimizerApiService = () => railyApiService(process.env.OPTIMIZER_URL);

  const getList = async (
    request: OrderOptimizerListRequest,
    abortSignal: AbortSignal,
  ): Promise<OrderOptimizerListResponse> => {
    const url = `/optimizations`;

    const queryParams: OrderOptimizerListRequestQueryParams =
      orderOptimizerListRequestFactory.createQueryParams(request);

    return optimizerApiService().get<OrderOptimizerListResponse>({
      url,
      abortSignal,
      queryParams,
    });
  };

  const getRoute = (
    request: SearchRoadRoutingRequest,
  ): Promise<SearchRoadRoutingResponse> => {
    return searchRoadRoutingService.search(request);
  };

  const getOtherDetails = async (
    request: OrderOptimizerDetailsOtherRequest,
    abortSignal: AbortSignal,
  ): Promise<OrderOptimizerDetailsOtherResponse> => {
    const url = `/optimizations/${request.optimizationId}/other`;
    const queryParams =
      orderOptimizerDetailsOtherRequestFactory.createQueryParams(request);

    return optimizerApiService().get<OrderOptimizerDetailsOtherResponse>({
      url,
      abortSignal,
      queryParams,
    });
  };

  const getCargoDetails = async (
    request: OrderOptimizerDetailsCargoRequest,
    abortSignal: AbortSignal,
  ): Promise<OrderOptimizerDetailsCargoResponse> => {
    const url = `/optimizations/${request.optimizationId}/cargo`;
    const queryParams =
      orderOptimizerDetailsCargoRequestFactory.createQueryParams(request);

    return optimizerApiService().get<OrderOptimizerDetailsCargoResponse>({
      url,
      abortSignal,
      queryParams,
    });
  };

  const getOptimizationStatus = async (
    request: OrderOptimizerOptimizationStatusRequest,
    abortSignal: AbortSignal,
  ): Promise<OrderOptimizerOptimizationStatusResponse> => {
    const url = `/optimizations/${request.optimizationId}/status`;

    return optimizerApiService().get({
      url,
      abortSignal,
    });
  };

  const getPotentialDriversList = async (
    request: OrderOptimizerPotentialDriversListRequest,
    abortSignal: AbortSignal,
  ): Promise<OrderOptimizerPotentialDriversListResponse> => {
    const url = `/optimizations/${request.optimizationId}/potential-drivers`;
    const queryParams: OrderOptimizerPotentialDriversListQueryParams =
      orderOptimizerPotentialDriversListRequestFactory.createQueryParams(
        request,
      );

    return optimizerApiService().get<OrderOptimizerPotentialDriversListResponse>(
      {
        url,
        abortSignal,
        queryParams,
      },
    );
  };

  const update = (
    request: OrderOptimizerDetailsUpdateRequest,
    abortSignal: AbortSignal,
  ): Promise<OrderOptimizerDetailsUpdateResponse> => {
    const url = `/optimizations/${request.id}`;
    const body = orderOptimizerDetailsUpdateRequestFactory.createBody(request);

    return optimizerApiService().put({
      url,
      abortSignal,
      body,
    });
  };

  return {
    getList,
    getRoute,
    getCargoDetails,
    getOtherDetails,
    getOptimizationStatus,
    getPotentialDriversList,
    update,
  };
};

export default orderOptimizerApiService;
